import {Component, input} from '@angular/core'
import {TApproval} from '../../0-application/types'
import {MatIcon} from '@angular/material/icon'
import {MatTooltip} from '@angular/material/tooltip'

@Component({
  selector: 'spb-approval-status-marker',
  imports: [
    MatIcon,
    MatTooltip
  ],
  templateUrl: './approval-status-marker.component.html',
  styleUrl: './approval-status-marker.component.scss'
})
export class ApprovalStatusMarker {
  public status = input.required<TApproval>()
}
